import { graphql } from 'react-relay';

export default graphql`
  query SSOPage_Query($clientId: String!) {
    viewer {
      id
      ...SSOPage_viewer @arguments(clientId: $clientId)
    }
  }
`;
